(function (algolia, addPriceInputs) {
  const client = algolia.externals.algoliasearch(
    algolia.config.app_id,
    algolia.config.search_api_key
  );
  const index = client.initIndex(algolia.config.index_prefix + 'products');
  class PDPPriceInputs {
    variantRadios;
    form;
    variants;
    algoliaIndex;
    addPriceInputs;

    constructor(algoliaIndex, addPriceInputs) {
      this.algoliaIndex = algoliaIndex;
      this.addPriceInputs = addPriceInputs;
      this.form = document.querySelector('.product-form form');

      this.variantRadios = document.querySelectorAll('variant-radios input');
      for (const variantRadio of this.variantRadios) {
        variantRadio.addEventListener('change', this.onVariantChange);
      }

      this.getVariants();
    }

    async getVariants() {
      const variantRadiosEl = document.querySelector('variant-radios');
      let variantIds = [document.querySelector('[name="id"]').value];

      if(!!variantRadiosEl) {
        variantIds = variantRadiosEl.dataset.variantIds.split(',');
      }

      const { results } = await this.algoliaIndex.getObjects(variantIds);
      this.variants = results;

      /**
       * Wait until variant data has been retrieved before re-enabling
       * variant options and the add to cart button so that discounts
       * can be properly applied when adding a product to cart
       */
      for (const variantRadio of this.variantRadios) {
        variantRadio.removeAttribute('disabled');
      }

      const addBtn = this.form.querySelector('#AddToCartButton');
      if (addBtn.dataset.unavailable == 'false') {
        addBtn.removeAttribute('disabled');
      }

      const stickyAtcButton = document.getElementById('StickyAddToCartButton');
      if (stickyAtcButton.dataset.unavailable == 'false') {
        stickyAtcButton.removeAttribute('disabled');
      }
    }

    getVariantByTitle(title) {
      for (const variant of this.variants) {
        if (variant.variant_title === title) {
          return variant;
        }
      }

      throw new Error(`Variant "${title}" is not found`);
    }

    onVariantChange = e => {
      const variantTitle = e.target.value;
      const variant = this.getVariantByTitle(variantTitle);
      this.addPriceInputs(this.form, variant);
    }
  }

  try {
    window.addEventListener('load', () => {
      new PDPPriceInputs(index, addPriceInputs);
    });
  } catch (err) {
    console.error(err);
  }

})(window.algoliaShopify, window.addPriceInputs);
